import React from 'react';
import { CheckCircle2, Mail } from 'lucide-react';
export function ThankYouPage() {
  return <div className="min-h-screen bg-brand-bg flex items-center justify-center px-4 py-12" data-id="element-741">
      <div className="max-w-lg w-full text-center" data-id="element-742">
        {/* Success Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-green/15 border border-brand-green/30 mb-6" data-id="element-743">
          <CheckCircle2 className="w-10 h-10 text-brand-green" data-id="element-744" />
        </div>

        {/* Heading */}
        <h1 className="text-3xl md:text-4xl font-bold text-white font-serif mb-3" data-id="element-745">
          ¡Gracias!
        </h1>
        <p className="text-xl md:text-2xl text-brand-gold font-semibold mb-6" data-id="element-746">
          Tu compra está completa
        </p>

        {/* Email Notice */}
        <div className="bg-brand-card border border-brand-gold/15 rounded-xl p-6 mb-8" data-id="element-747">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-gold/10 mb-4" data-id="element-748">
            <Mail className="w-6 h-6 text-brand-gold" data-id="element-749" />
          </div>
          <p className="text-brand-text/90 text-base md:text-lg leading-relaxed" data-id="element-750">
            A tu correo electrónico le han llegado tus{' '}
            <strong className="text-white" data-id="element-751">datos de acceso</strong>.
          </p>
          <p className="text-brand-muted text-sm mt-3" data-id="element-752">
            Revisa tu bandeja de entrada y también la carpeta de spam o
            promociones.
          </p>
        </div>

        <div className="w-16 h-px bg-brand-gold/30 mx-auto mb-6" data-id="element-753"></div>

        <p className="text-brand-muted text-sm" data-id="element-754">
          Si tienes alguna pregunta, no dudes en contactarnos.
        </p>
      </div>
    </div>;
}